// extracted by mini-css-extract-plugin
export default {"viewer":"Viewer_viewer__mOHyq"};